import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import Button from 'design-system/Button';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import IconSpace from 'design-system/icons/IconSpace';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import TouchableOpacity from 'utils/packages/TouchableOpacity';
import createStyleSheets from 'utils/createStyleSheets';
import { TAB_SCREEN_HEADER_HEIGHT_WEB } from 'navigators/styles';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { IconBell } from 'design-system/icons';
import { selectActiveReferralProgramReward } from 'features/inviteFriend/selectors';
import { selectExpiredSpacesCount } from 'features/spaces/reducers/selectors';
import NotificationCount from 'features/notifications/components/NotificationCount';
import { selectFeatureFlag, selectInviteWithNumberOfInvites, } from 'reducers/selectors';
import Amplitude from 'utils/amplitude';
import { formatAmount } from 'utils';
import { selectFeedHeader } from '../selectors';
const FeedHeader = () => {
    const nav = useMainStackNavigation();
    const { notificationsNum } = useAppSelector(selectFeedHeader);
    const { invite, numInvites } = useAppSelector(selectInviteWithNumberOfInvites);
    const expiredSpacesCount = useAppSelector(selectExpiredSpacesCount) || 0;
    const styles = useStyles(styleSet);
    const colors = useColors();
    const onPressNotifications = useCallback(() => {
        nav.navigateDeprecated('NotificationsList');
    }, [nav]);
    const onPressSpaces = useCallback(() => {
        if (invite) {
            nav.navigateDeprecated('SpaceInvite', {
                spaceId: invite.spaceId,
                inviteId: invite.id,
                fromHeader: true,
            });
            return;
        }
        nav.navigateDeprecated('MySpaces');
    }, [invite, nav]);
    const handleInvite = useCallback(() => {
        nav.navigateDeprecated('InviteScreen');
        Amplitude.logEvent('Open Invite', { source: 'feed_header' });
    }, [nav]);
    const referralButtonFlag = useAppSelector((store) => selectFeatureFlag(store, 'referrals_get_button_feed').value);
    const activeReferralProgram = useAppSelector(selectActiveReferralProgramReward);
    const showReferralsButton = referralButtonFlag && !!activeReferralProgram;
    const spaceNotificationCount = expiredSpacesCount + numInvites;
    return (<View style={styles.safeAreaContainer}>
      <View style={styles.container}>
        <View style={styles.iconContainer}>
          {showReferralsButton ? (<>
              <Button title={`Get ${formatAmount(activeReferralProgram.get, activeReferralProgram.currency)}`} small extra cards brand onPress={handleInvite}/>
              <Spacer w={8}/>
            </>) : null}
          <TouchableOpacity hoverOnDark onPress={onPressSpaces} accessibilityHint="Spaces" style={styles.navButton}>
            <IconSpace color={colors.elements.primary}/>
            <NotificationCount top={8} left={spaceNotificationCount > 999 ? 14 : 18} count={spaceNotificationCount}/>
          </TouchableOpacity>
          <Spacer w={8}/>
          <TouchableOpacity hoverOnDark style={styles.navButton} onPress={onPressNotifications} accessibilityHint="Notifications">
            <IconBell color={colors.elements.primary}/>
            <NotificationCount top={8} left={notificationsNum > 999 ? 14 : 18} count={notificationsNum}/>
          </TouchableOpacity>
        </View>
      </View>
    </View>);
};
const styleSet = createStyleSheets(() => ({
    safeAreaContainer: {
        flex: 1,
    },
    container: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        paddingHorizontal: rem(16),
        height: TAB_SCREEN_HEADER_HEIGHT_WEB,
    },
    iconContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    navButton: {
        width: 40,
        height: 40,
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'center',
    },
}));
export default memo(FeedHeader);
